import { ComboForm } from '@/modules/product/add-combo';
import { createFileRoute, useSearch } from '@tanstack/react-router';
import { z } from 'zod';

const searchSchema = z.object({
  id: z.coerce.string().optional(),
  step: z.string().optional(),
});

export const Route = createFileRoute(
  '/dashboard/product/combo/add-combination/'
)({
  validateSearch: searchSchema,
  component: AddCombinationPage,
});

function AddCombinationPage() {
  const { id: comboId } = useSearch({
    from: '/dashboard/product/combo/add-combination/',
  });

  return <ComboForm initialComboId={comboId || null} />;
}
